export type EntryValuesType = {
  code: string
  title: string
  duration: number
}

export type CoversListType = {
  name: string
  description: string
}

export type CountriesMappingType = Record<
  string,
  {
    areaCodes: Nullable<string[]>
    dialCode?: string
    flag: string
    iso?: string
    mask?: string
    name?: string
    placeholder?: string
    priority: number
  }
>

export enum CONTACTS_KEYS {
  EMAIL = 'email_qatar_visitors',
  WALINK_GENERAL = 'walink_qatar_general',
  WALINK_MANDATORY = 'walink_qatar_visitors',
  PHONELINK = 'phonelink_qatar_general',
  PHONELINK_TEXT = 'phone_qatar_general',
}

export interface EnterpriseContact {
  ContactKey: string
  ContactType: string
  Product: string
  Region: string
  Value: string
}

export enum VisitorsDirection {
  PURCHASE = 'PURCHASE',
  POLICY_DOWNLOAD = 'POLICY_DOWNLOAD',
  UNKNOWN = 'UNKNOWN',
}

export interface WordingParams {
  categoryid: string
  docname: string
}

export type CountriesType = {
  code: string
  desc: string
  flag: string
  popularNationality: number
  popularCountry: number
  mask?: string
  searchString: string
}

export type CountryWithDetailsType = CountriesType & {
  name: string
  iso: string
}

export type EmailDomain = {
  domain: string
  level: number
}

export type MaritalStatus = {
  code: string;
  name: string;
}

export type Environment = 'production' | 'development'